export default __webpack_public_path__ + "static/squiddao-65a83d79d610738f9981bd4369e23af8.jpg";